(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ugc-videos"] && !Shopify.designMode) return;
  try {
    (function() {
  function initUGC() {
    document.querySelectorAll('.ugc-block__item[data-lightbox]').forEach(function(btn) {
      if (btn.dataset.ugcInit) return;
      btn.dataset.ugcInit = '1';
      btn.addEventListener('click', function() {
        var lbId = btn.dataset.lightbox;
        var lb = document.getElementById(lbId);
        if (!lb) return;
        var video = lb.querySelector('.ugc-lightbox__video');
        var iframe = lb.querySelector('.ugc-lightbox__iframe');
        var muteBtn = lb.querySelector('.ugc-lightbox__mute');
        if (!video || !iframe) return;

        var kind = btn.dataset.kind;

        if (kind === 'file') {
          iframe.hidden = true;
          iframe.src = '';
          video.hidden = false;

          if (muteBtn) muteBtn.hidden = true;
          var hasAudio = btn.dataset.audio === 'true';

          // Set muted state BEFORE assigning src/load, so the browser
          // respects it immediately regardless of how fast 'canplay' fires
          // (avoids a race where canplay fires before a later listener attaches).
          video.muted = !hasAudio;
          video.src = btn.dataset.src;
          lb.classList.add('is-open');
          video.load();

          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function() {
              // Autoplay with sound can be blocked; retry muted so the video still plays.
              if (!video.muted) {
                video.muted = true;
                video.play();
              }
            });
          }

          if (muteBtn) {
            if (hasAudio) {
              muteBtn.hidden = false;
              updateMuteBtn(muteBtn, video.muted);
            } else {
              muteBtn.hidden = true;
            }
          }
        } else {
          video.pause();
          video.src = '';
          video.hidden = true;
          if (muteBtn) muteBtn.hidden = true;

          iframe.hidden = false;
          iframe.src = btn.dataset.embed;
          lb.classList.add('is-open');
        }

        document.body.style.overflow = 'hidden';
      });
    });

    document.querySelectorAll('.ugc-lightbox__mute').forEach(function(btn) {
      if (btn.dataset.muteInit) return;
      btn.dataset.muteInit = '1';
      btn.addEventListener('click', function() {
        var lb = btn.closest('.ugc-lightbox');
        var video = lb.querySelector('.ugc-lightbox__video');
        if (!video) return;
        video.muted = !video.muted;
        updateMuteBtn(btn, video.muted);
      });
    });

    document.querySelectorAll('[data-close-lightbox]').forEach(function(el) {
      if (el.dataset.ugcCloseInit) return;
      el.dataset.ugcCloseInit = '1';
      el.addEventListener('click', function() {
        var lbId = el.dataset.closeLightbox;
        var lb = document.getElementById(lbId);
        if (!lb) return;
        var video = lb.querySelector('.ugc-lightbox__video');
        var iframe = lb.querySelector('.ugc-lightbox__iframe');
        lb.classList.remove('is-open');
        if (video) { video.pause(); video.src = ''; video.hidden = false; }
        if (iframe) { iframe.src = ''; iframe.hidden = true; }
        document.body.style.overflow = '';
      });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.ugc-lightbox.is-open').forEach(function(lb) {
        var video = lb.querySelector('.ugc-lightbox__video');
        var iframe = lb.querySelector('.ugc-lightbox__iframe');
        lb.classList.remove('is-open');
        if (video) { video.pause(); video.src = ''; video.hidden = false; }
        if (iframe) { iframe.src = ''; iframe.hidden = true; }
        document.body.style.overflow = '';
      });
    });

    document.querySelectorAll('.ugc-block__track').forEach(function(track) {
      var dots = track.parentElement.querySelectorAll('.ugc-block__dot');
      if (!dots.length) return;
      var items = track.querySelectorAll('.ugc-block__item');
      track.addEventListener('scroll', function() {
        var idx = Math.round(track.scrollLeft / (track.scrollWidth / items.length));
        dots.forEach(function(d, i) { d.classList.toggle('is-active', i === idx); });
      }, { passive: true });
    });
  }

  function updateMuteBtn(btn, isMuted) {
    var iconMuted = btn.querySelector('.icon-muted');
    var iconUnmuted = btn.querySelector('.icon-unmuted');
    btn.dataset.muted = isMuted ? 'true' : 'false';
    btn.setAttribute('aria-label', isMuted ? 'Activar sonido' : 'Silenciar');
    if (iconMuted) iconMuted.style.display = isMuted ? '' : 'none';
    if (iconUnmuted) iconUnmuted.style.display = isMuted ? 'none' : '';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUGC);
  } else {
    initUGC();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
